import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {SelectedNodesData} from 'common/src/components/CLCardsMap/CardsMapContainer/CardsMapContainer.types';
import {ReactNode} from 'react';

enum DTControlMode {
  Default = 'default',
  Comments = 'comments',
  Issues = 'issues',
  TearSheets = 'tearsheets',
  AnalyticsDashboard = 'dashboard',
  Preview = 'preview',
  AdsGenerationHistory = 'adsGenerationHistory',
}

interface NodeDragPosition {
  lastX: number;
  lastY: number;
}

type NodeOutputWithContent = {
  text?: string | number | string[] | number[];
  isFallback?: boolean;
  isLastOutput?: boolean;
  outputValue?: number;
  textInTooltip?: string | number | string[] | number[] | ReactNode;
};

interface FCSelectedNodesData extends SelectedNodesData {
  isFallbackCreative: boolean;
}

type CampaignTypeConfig = {
  name: string;
  icon: string;
  settingsComponent: ReactNode;
  campaignNodeComponent: ReactNode;
  enabledNodes: NodeType[];
  creativeNodeType: NodeType;
  variationsComponent?: ReactNode;
  iconBgColor?: string;
  iconTooltip?: string;
  creativeNodeSettingsComponent?: ReactNode;
  isFallbackCreativeSupported: boolean;
};

export {
  CampaignTypeConfig,
  DTControlMode,
  FCSelectedNodesData,
  NodeDragPosition,
  NodeOutputWithContent,
};
